import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { PaymentCollectionModel } from "@store/Types/PaymentHistory";

const paymentHistoryServiceUrl = "/api/v1/paymenthistory";

export interface GetPaymentHistoryApiParameter extends ApiParameter, HasPagingParameters {
    checkNumber?: string;
    checkAmount?: string;
    fromDate?: string;
    toDate?: string;
}

export function getPaymentHistoryCollection(parameter: GetPaymentHistoryApiParameter) {
    return get<PaymentCollectionModel>(`${paymentHistoryServiceUrl}`, parameter);
}
